module.exports = __webpack_public_path__ + "img/ic_introduce_bottom_left.fe476448.png";